import React from 'react';
import { Box, Typography, Button, Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

function UnauthorizedScreen() {
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  const handleGoHome = () => {
    history.push('/');
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      style={{ width: '100%', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
    >
      <LockOutlinedIcon style={{ fontSize: 80, color: '#9e9e9e', marginBottom: 24 }} />
      <Typography variant="h4" gutterBottom>
        Access Denied
      </Typography>
      <Typography variant="body1" color="textSecondary" style={{ marginBottom: 24, textAlign: 'center', maxWidth: 400 }}>
        You don't have permission to access this page.
      </Typography>
      <Grid spacing={2} container justifyContent="center" alignItems="center">
        <Button variant="outlined" color="primary" onClick={handleGoBack} style={{ marginRight: 8 }}>
          Go Back
        </Button>
        <Button variant="contained" color="primary" onClick={handleGoHome}>
          Go to Home
        </Button>
      </Grid>
    </Box>
  );
}

export default UnauthorizedScreen;
